<template>
  <b-overlay
    :show="loading"
  >
    <b-card
      title="جزئیات لیست غذایی"
    >
      <b-row align-h="center">
        <b-col md="10">
          <b-form-group
            label="عنوان"
            label-for="Title"
          >
            <b-form-input
              id="Title"
              :value="getTitle"
              name="Title"
              :disabled="true"
              autocomplete="off"
            />
          </b-form-group>
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              id="Description"
              v-model="Form.Description"
              name="Description"
              rows="5"
              no-resize
            />
          </b-form-group>
          <draggable
            v-model="Form.FoodListRow"
            tag="ul"
            class="list-group list-group-flush cursor-move"
          >
            <b-row
              v-for="(item, index) in Form.SpecialDietFoodListRow"
              :key="index"
              tag="li"
              class="mb-1 border-dark pt-1"
            >
              <b-col
                class="foodlist"
                md="3"
              >
                <b-form-group
                  label="غذا"
                >
                  <z-food
                    :value="item.SpecialDietFoodListRowDetails.map(food => food.FoodId)"
                    class="w-100"
                    :multiple="true"
                    @selectedItem="setSelectedFoods($event,item)"
                    @deselected="item.SpecialDietFoodListRowDetails = item.SpecialDietFoodListRowDetails.filter(f=>f.FoodId !== $event.Id)"
                  />
                </b-form-group>
              </b-col>
              <b-col
                class="foodlist"
                md="1"
              >
                <b-form-group
                  label="اصلی"
                >
                  <b-form-checkbox
                    v-model="item.IsMain"
                    class="mt-auto"
                  />
                </b-form-group>
              </b-col>
              <b-col md="8">
                <b-row
                  v-for="selectedFood in item.SpecialDietFoodListRowDetails"
                >
                  <b-col md="4">
                    <b-form-group
                      :label="`واحد ${getFoodTitle(selectedFood.FoodId)}`"
                    >
                      <foodunit
                        v-model="selectedFood.FoodUnitId"
                        :clearable="true"
                        @selectedItem="setSelectedUnit($event,selectedFood)"
                      />

                    </b-form-group>
                  </b-col>
                  <b-col md="8">
                    <b-form-group
                      :label="`توضیحات ${getFoodTitle(selectedFood.FoodId)}`"
                    >
                      <b-form-input
                        v-model="selectedFood.Description"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                class="mb-1 mr-auto text-right"
                align-self="end"
              >
                <trash
                  v-model="Form.SpecialDietFoodListRow"
                  :index="index"
                />
              </b-col>
            </b-row>
          </draggable>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="gradient-info"
            class="mb-1"
            @click="addFood"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            <span>افزودن</span>
          </b-button>
          <div
            class="mt-1 mb-2 text-right"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              @click="save"
            >
              ذخیره
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="back"
            >
              بازگشت
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>

import { VBTooltip } from 'bootstrap-vue'
import ZFood from '@/tools/food.vue'
import draggable from 'vuedraggable'
import Foodunit from '@/tools/foodunit.vue'
import { mapState } from 'vuex'

export default {
  name: 'AddDedicatedFoodList',
  components: {
    Foodunit,
    ZFood,
    draggable,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      Status: [],
      foodArray: [],
      Form: {
        Id: null,
        Title: null,
        Description: null,
        SpecialDietFoodListRow: [],
      },
      FoodRemoveId: null,
      loading: false,
      saveUrl: null,
      selectedFoods: [],
    }
  },
  computed: {
    ...mapState('zirehState', { foods: state => state.foodSelect }),
    ...mapState('zirehState', { foodUnits: state => state.foodUnitSelect }),
    getTitle() {
      if (this.Form.SpecialDietFoodListRow.length === 0) return ''
      let title = ''
      if (this.foods && this.foods.length) {
        this.Form.SpecialDietFoodListRow.forEach((item, index) => {
          if (index !== 0) title += ' + '
          item.SpecialDietFoodListRowDetails.forEach((sf, indexSf) => {
            if (indexSf !== 0) title += ' یا '
            title += this.foods.filter(x => x.Id === sf.FoodId)[0].Title
          })
        })
      }
      return title
    },
    getFoodTitle() {
      return id => {
        let title = ''
        if (this.foods && this.foods.length) {
          title = this.foods.filter(x => x.Id === id)[0].Title
        }
        return title
      }
    },
  },
  created() {
    if (this.$route.params.clone) {
      // clone
      this.Form.Id = this.$route.params.listFoodId
      this.saveUrl = this.$api.dedicatedfoodList.add
      this.get()
    } else if (this.$route.params.listFoodId) {
      // edit
      this.Form.Id = this.$route.params.listFoodId
      this.saveUrl = this.$api.dedicatedfoodList.update
      this.get()
    } else {
      // add
      this.saveUrl = this.$api.dedicatedfoodList.add
      this.addFood()
    }
  },
  methods: {
    setSelectedUnit($event, selectedFood) {
      selectedFood.FoodUnitId = $event.Id
    },
    setSelectedFoods(selectedFood, item) {
      const foodsId = item.SpecialDietFoodListRowDetails.map(sf => sf.FoodId)
      selectedFood.filter(sf => !foodsId.includes(sf.Id))
        .forEach(sf => {
          item.SpecialDietFoodListRowDetails.push({
            FoodId: sf.Id,
            FoodUnitId: null,
          })
        })
    },
    save() {
      this.loading = true
      this.Form.Title = this.getTitle
      this.$http.post(
        this.saveUrl, this.Form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.dedicatedfoodList.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    addFood() {
      this.Form.SpecialDietFoodListRow.push({ SpecialDietFoodListRowDetails: [], IsMain: false })
    },
  },
}
</script>
